// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__erIpW","right":"styles_right__39bxF"};